module.exports = __webpack_public_path__ + "8c42af616429eb090c11f8f1c7d7d9b2.svg";